import styled from 'styled-components';

export const FrameWrapper = styled.div`
	height: calc(100vh - 125px);
`;
